import React, { useState } from "react";
import "./ProofreadingEstimation.css";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../config/locales";
import { useLocalizedUrl } from "../common/useLocalizedUrl";
import { postUploadDocxForProofreading } from "../../core/api/Api";
import { showToast } from "../../core/common-service/CommonService";
import ProofreadingConfirmModal from "./ProofreadingConfirmModal";

const ProofreadingEstimation = () => {
  const { t, i18n } = useTranslation();
  const { getUrl } = useLocalizedUrl();
  const [file, setFile] = useState(null);
  const [wordCount, setWordCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasEstimation, setHasEstimation] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (
      selectedFile &&
      selectedFile.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      setFile(selectedFile);
      calculatePrice(selectedFile);
    }
  };

  const calculatePrice = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    postUploadDocxForProofreading(formData)
      .then((response) => {
        setWordCount(response.data.wordCount);
        setPrice(response.data.price);
        setHasEstimation(true);
      })
      .catch(() => {
        showToast({ type: "error", message: t("error.unknown_error") });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const openAppointmentUrl = () => {
    window.open(
      getUrl("/contact-faire-relire-et-corriger-son-livre/"),
      "_blank",
    );
  };

  const handleAppointmentClick = () => {
    if (!hasEstimation) {
      setShowConfirmModal(true);
      return;
    }
    openAppointmentUrl();
  };

  const handleConfirmProceed = () => {
    setShowConfirmModal(false);
    openAppointmentUrl();
  };

  return (
    <section className="py-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="proofreading-section">
              <h1>{t("proofreading.title")}</h1>

              <div className="custom-file-upload">
                <label
                  className="custom-file-label"
                  htmlFor="proofreading-file-upload"
                >
                  {file ? file.name : t("proofreading.upload_placeholder")}
                </label>
                <input
                  id="proofreading-file-upload"
                  type="file"
                  accept=".docx"
                  onChange={handleFileChange}
                  className="file-input-hidden"
                />
              </div>

              {loading && <p className="loading-text">{t("processing")}</p>}

              {hasEstimation && !loading && (
                <div className="result">
                  <p>
                    {t("proofreading.word_count")}:{" "}
                    <span className="value">{wordCount}</span>
                  </p>
                  <p>
                    {t("proofreading.estimated_price")}:{" "}
                    <span className="value">{formatPrice(price, i18n.language)}</span>
                  </p>
                </div>
              )}

              <div>
                <button
                  className="appointment-button"
                  onClick={handleAppointmentClick}
                >
                  {t("proofreading.book_appointment")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProofreadingConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onProceed={handleConfirmProceed}
      />
    </section>
  );
};

export default ProofreadingEstimation;
